// Het live voorbeeld op de kleurenpagina van het dashboard (golf 1B, Martijn 10-10-2026).
//
// Het dashboard toont deze widget in een iframe met ?voorbeeld=1 en stuurt bij elke kleurwijziging een bericht:
//   { type: 'jimani-voorbeeld-opmaak', velden: { veldnaam: waarde, ... }, opmaak: { lettertypeCss, hoekafronding } }
// De widget zet die waarden over de opgehaalde opmaak heen, zonder opslaan. Buiten het voorbeeld (gewoon op een website)
// luistert de widget nergens naar: alleen met voorbeeld=1 in het adres, en alleen naar de pagina die hem insluit.

export const VOORBEELD_TYPE = 'jimani-voorbeeld-opmaak';
export const GEREED_TYPE = 'jimani-voorbeeld-gereed';

/** Staat de widget als voorbeeld in het dashboard? */
export function isVoorbeeld(zoek) {
    try {
        return new URLSearchParams(zoek ?? (typeof window !== 'undefined' ? window.location.search : '')).get('voorbeeld') === '1';
    } catch {
        return false;
    }
}

/** Is dit een geldig voorbeeldbericht? */
export function isVoorbeeldbericht(data) {
    return !!data && typeof data === 'object' && data.type === VOORBEELD_TYPE && !!data.velden && typeof data.velden === 'object';
}

/**
 * Zet de voorbeeldwaarden in de opmaakgroepen (settings.cssGroup: [{ cssTabFieldsGroupName, fields: {...} }]).
 * Alleen velden die een groep al kent worden overschreven; niets anders verandert. Geeft een nieuwe lijst terug.
 */
export function pasVeldenToe(groepen, velden) {
    if (!Array.isArray(groepen) || !velden) return groepen;

    return groepen.map((groep) => {
        const fields = groep?.fields;
        if (!fields || typeof fields !== 'object') return groep;

        const nieuw = { ...fields };
        let anders = false;

        for (const sleutel of Object.keys(fields)) {
            const waarde = velden[sleutel];
            if (typeof waarde === 'string' && waarde && waarde !== fields[sleutel]) {
                nieuw[sleutel] = waarde;
                anders = true;
            }
        }

        return anders ? { ...groep, fields: nieuw } : groep;
    });
}

/** Lettertype en hoek uit een bericht of uit de instellingen (settings.opmaak), schoon. Null als er niets is. */
export function leesOpmaak(opmaak) {
    if (!opmaak || typeof opmaak !== 'object') return null;

    const css = typeof opmaak.lettertypeCss === 'string' ? opmaak.lettertypeCss.replace(/[;{}<>]/g, '').trim() : '';
    const hoek = Number.parseInt(opmaak.hoekafronding, 10);

    return {
        lettertypeCss: css || null,
        hoekafronding: Number.isFinite(hoek) ? Math.max(0, Math.min(24, hoek)) : null,
    };
}
